var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-type-ahead',{attrs:{"value":_vm.value,"data":_vm.data,"loader":_vm.loader,"processResults":_vm.processResults,"use-tags":false,"minimum-input-length":2},on:{"input":_vm.changed}})}
var staticRenderFns = []

export { render, staticRenderFns }